import { schema } from "normalizr";

const RoleSchema = new schema.Entity("roles");
const RoleArraySchema = new schema.Array(RoleSchema);

export { RoleSchema, RoleArraySchema };